// extracted by css-extract-rspack-plugin
export default {"nav":"sZum9LcaBce3L2LY","list":"BRj4_Td18wwwNtgI","tab":"N4kwUEF1bH8AvWvO","groupTrigger":"Mjmzl4kDuT4sfLlN","caret":"utTQBcVEKf8XHbzP"};